import React from "react";

const Subscription = () => {
  const partialFeatures = [
    { text: "Basic OPD Queue tracking", included: true },
    { text: "Single Doctor Profile", included: true },
    { text: "Standard Appointment View", included: true },
    { text: "Advanced Patient HealthMap & History", included: false },
    { text: "Smart PDF Receipt & Prescription Maker", included: false },
    { text: "Deep Revenue & Patient Analytics", included: false },
    { text: "Multi-Account & Workspace Hub", included: false },
    { text: "Priority 24/7 Dedicated Doctor Support", included: false },
  ];

  const fullFeatures = [
    { text: "Live OPD Queue & Real-time Slot Config", included: true },
    { text: "Complete Patient HealthMap & History Tracking", included: true },
    { text: "Smart PDF Receipt & Prescription Maker", included: true },
    { text: "Deep Revenue Analytics, Metrics & Frequent Items", included: true },
    { text: "Multi-Account & Workspace Hub Integration", included: true },
    { text: "Custom Clinic Branding (Logo & Signature)", included: true },
    { text: "Automated Patient Notifications & Reminders", included: true },
    { text: "Priority 24/7 Dedicated Doctor Support", included: true },
  ];

  return (
    <div className="w-full space-y-6 pb-12 max-w-7xl mx-auto">
      {/* Header Banner */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-gray-900 via-primary-950 to-emerald-950 p-6 sm:p-8 text-white shadow-xl">
        <div className="absolute top-0 right-0 -mt-10 -mr-10 w-64 h-64 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-1/3 -mb-10 w-64 h-64 bg-primary-500/10 rounded-full blur-3xl pointer-events-none" />

        <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="space-y-2 max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/20 border border-emerald-400/30 text-emerald-300 text-xs font-semibold tracking-wide">
              <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
              100% COMPLIMENTARY ACCESS
            </div>
            <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-white">
              Subscription & Membership
            </h1>
            <p className="text-gray-300 text-sm sm:text-base leading-relaxed">
              Empowering your medical practice with full-suite Smart Clinic automation. Enjoy complete access with zero subscription fees.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-md border border-white/15 p-4 sm:p-5 rounded-2xl shrink-0 flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-emerald-500/20 border border-emerald-400/40 flex items-center justify-center text-emerald-400 shrink-0">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
              </svg>
            </div>
            <div>
              <span className="text-xs font-semibold text-gray-300 block uppercase tracking-wider">Your Active Tier</span>
              <span className="text-lg font-bold text-white flex items-center gap-1.5">
                Full Access
                <span className="text-xs bg-emerald-500 text-gray-950 font-black px-2 py-0.5 rounded-md">ACTIVE</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Subscription Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 items-stretch">
        {/* Partial Access Card */}
        <div className="bg-white rounded-3xl p-6 sm:p-8 border border-gray-200/90 shadow-sm flex flex-col justify-between hover:shadow-md transition-all duration-300 relative group">
          <div>
            <div className="flex items-center justify-between gap-4 mb-4">
              <span className="px-3 py-1 rounded-full bg-gray-100 text-gray-700 text-xs font-bold uppercase tracking-wider">
                Starter Tier
              </span>
              <span className="text-xs font-medium text-gray-400">Basic Features</span>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2">Partial Access</h3>
            <p className="text-gray-500 text-sm mb-6 leading-relaxed">
              Standard access suited for initial onboarding with core appointment tracking and basic features.
            </p>

            <div className="mb-6 pb-6 border-b border-gray-100">
              <div className="flex items-baseline gap-1">
                <span className="text-3xl font-black text-gray-900">₹0</span>
                <span className="text-gray-500 text-sm font-medium">/ month</span>
              </div>
              <span className="text-xs text-gray-400 mt-1 block">Free Tier</span>
            </div>

            {/* Feature List */}
            <div className="space-y-3 mb-8">
              <span className="text-xs font-bold uppercase text-gray-400 tracking-wider block mb-2">
                Included Features & Limits
              </span>
              {partialFeatures.map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  {item.included ? (
                    <div className="w-5 h-5 rounded-full bg-emerald-50 text-emerald-600 flex items-center justify-center shrink-0">
                      <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                  ) : (
                    <div className="w-5 h-5 rounded-full bg-gray-100 text-gray-400 flex items-center justify-center shrink-0">
                      <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </div>
                  )}
                  <span className={`text-sm ${item.included ? "text-gray-700 font-medium" : "text-gray-400 line-through"}`}>
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <button
              disabled
              className="w-full py-3.5 px-6 rounded-2xl bg-gray-100 text-gray-400 font-bold text-sm cursor-not-allowed border border-gray-200/60"
            >
              Basic Tier (Upgraded to Full)
            </button>
          </div>
        </div>

        {/* Full Access Card (ACTIVE) */}
        <div className="bg-gradient-to-b from-white via-emerald-50/20 to-emerald-50/40 rounded-3xl p-6 sm:p-8 border-2 border-emerald-500/80 shadow-lg shadow-emerald-500/10 flex flex-col justify-between relative overflow-hidden group">
          {/* Glowing Top Ribbon */}
          <div className="absolute top-0 left-0 right-0 h-1.5 bg-gradient-to-r from-emerald-400 via-teal-500 to-emerald-600" />

          <div>
            <div className="flex items-center justify-between gap-4 mb-4">
              <span className="px-3.5 py-1 rounded-full bg-emerald-500 text-white text-xs font-black uppercase tracking-wider shadow-xs flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
                ACTIVE PLAN
              </span>
              <span className="text-xs font-bold text-emerald-700 bg-emerald-100/80 px-2.5 py-1 rounded-lg">
                Complimentary Availed
              </span>
            </div>

            <div className="flex items-center gap-2 mb-2">
              <h3 className="text-2xl font-black text-gray-900">Full Access</h3>
              <span className="text-xl">✨</span>
            </div>
            <p className="text-gray-600 text-sm mb-6 leading-relaxed">
              Unrestricted access to all current and upcoming OPD Smart Clinic features, real-time analytics, and automated queues.
            </p>

            <div className="mb-6 pb-6 border-b border-emerald-100">
              <div className="flex items-baseline gap-2">
                <span className="text-3xl font-black text-gray-900">₹0</span>
                <span className="text-gray-500 text-sm font-medium">/ month</span>
                <span className="text-sm font-bold text-gray-400 line-through ml-2">₹2,999/mo</span>
              </div>
              <span className="text-xs font-extrabold text-emerald-600 mt-1 inline-flex items-center gap-1">
                🎉 100% Free Special Promotion — Currently Active for Your Practice
              </span>
            </div>

            {/* Feature List */}
            <div className="space-y-3 mb-8">
              <span className="text-xs font-bold uppercase text-emerald-800 tracking-wider block mb-2">
                All-Inclusive Premium Features
              </span>
              {fullFeatures.map((item, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-emerald-500 text-white flex items-center justify-center shrink-0 shadow-xs">
                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-sm text-gray-800 font-semibold">
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <button
              type="button"
              className="w-full py-3.5 px-6 rounded-2xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2 cursor-default"
            >
              <svg className="w-5 h-5 text-emerald-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Currently Active & Availed</span>
            </button>
          </div>
        </div>
      </div>

      {/* Feature Comparison Highlights */}
      <div className="bg-white rounded-3xl p-6 sm:p-8 border border-gray-200/90 shadow-xs">
        <h3 className="text-lg font-extrabold text-gray-900 mb-6 flex items-center gap-2">
          <svg className="w-5 h-5 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          Why Full Access Tier Elevates Your Practice
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="p-4 rounded-2xl bg-gray-50 border border-gray-100 space-y-1.5">
            <div className="w-9 h-9 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center font-black mb-2">
              ⚡
            </div>
            <h4 className="text-sm font-bold text-gray-900">Live OPD Queue</h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              Real-time patient tracking with token queue management and dynamic slot status.
            </p>
          </div>

          <div className="p-4 rounded-2xl bg-gray-50 border border-gray-100 space-y-1.5">
            <div className="w-9 h-9 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center font-black mb-2">
              📊
            </div>
            <h4 className="text-sm font-bold text-gray-900">Smart Insights</h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              Detailed analytics on revenue, patient visits, and frequent medication usage.
            </p>
          </div>

          <div className="p-4 rounded-2xl bg-gray-50 border border-gray-100 space-y-1.5">
            <div className="w-9 h-9 rounded-xl bg-amber-50 text-amber-600 flex items-center justify-center font-black mb-2">
              📄
            </div>
            <h4 className="text-sm font-bold text-gray-900">Instant PDF Receipts</h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              Generate digital receipts and prescriptions with custom clinic logo and signature.
            </p>
          </div>

          <div className="p-4 rounded-2xl bg-gray-50 border border-gray-100 space-y-1.5">
            <div className="w-9 h-9 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center font-black mb-2">
              🔄
            </div>
            <h4 className="text-sm font-bold text-gray-900">Multi-Account Hub</h4>
            <p className="text-xs text-gray-500 leading-relaxed">
              Seamlessly toggle between doctor profiles and clinics without re-logging in.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
